// Cameras that may not be used in Duet rooms, matched against the device label
const BLOCKED_CAMERA_PATTERNS = [
  /\bobs\b.*virtual\s*cam/i, // E.g. OBS Virtual Camera
  /\bobs-camera\d*\b/i, // Pre-OBS 26 obs-virtualcam plugin
];

export const BLOCKED_CAMERA_ERROR = 'BlockedCameraError';

export const isBlockedCamera = (label) => (
  BLOCKED_CAMERA_PATTERNS.some((pattern) => pattern.test(label || ''))
);

export const getAllowedVideoDevices = (devices) => devices
  .filter((d) => d.kind === 'videoinput' && !isBlockedCamera(d.label));

/** Stops all tracks and throws if any come from a blocked camera */
export function assertNotBlockedCamera(mediaStreamTracks) {
  if (!mediaStreamTracks.some((t) => t.kind === 'video' && isBlockedCamera(t.label))) return;

  mediaStreamTracks.forEach((t) => t.stop());
  const error = new Error('This camera is not allowed');
  error.name = BLOCKED_CAMERA_ERROR;
  throw error;
}
